import { render, staticRenderFns } from "./bookLoading.vue?vue&type=template&id=662e768c&scoped=true&"
import script from "./bookLoading.vue?vue&type=script&lang=js&"
export * from "./bookLoading.vue?vue&type=script&lang=js&"
import style0 from "./bookLoading.vue?vue&type=style&index=0&id=662e768c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662e768c",
  null
  
)

export default component.exports